export default "__VITE_ASSET__gePST0sd__"